import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { ButtonGroup, InternalGrid } from '@paygreen/paygreen-ui';
import { LineKeyValue } from '../../index';
import { IsMobile } from '../../../utils/tools';

const DisplayForm = ({
    t,
    data,
    isLoading,
    inputsNames,
    i18labelBase,
    children,
}) => {
    // we transform phone value received from API for beter readability
    const shortedPhone = data?.phone?.slice(4);
    const phoneWithSpaces =
        shortedPhone &&
        [...shortedPhone]
            .map((letter, index) => (index % 2 !== 0 ? ' ' + letter : letter))
            .join('')
            .trim();
    const internationalPhone = data?.phone ? '+33 (0)' + phoneWithSpaces : null; // in case there is no phone provided, we return null

    return (
        <>
            <InternalGrid
                displayType="grid"
                gridTemplateColumns={IsMobile() ? '1fr' : 'auto 1fr'}
                justifyItems="stretch"
                alignItems={isLoading ? 'stretch' : 'center'}
                gridGap="md"
                childrenMarginTop="none"
                childrenMarginBottom="none"
            >
                {inputsNames.map((element) => (
                    <LineKeyValue
                        key={element.name}
                        keyLabel={t(
                            i18labelBase + '.' + element.name + 'Input',
                        )}
                        keyValue={
                            element.name === 'country'
                                ? t(`countries:${data[element.name]}`)
                                : element.name === 'phone'
                                ? internationalPhone
                                : data[element.name]
                        }
                        isLoading={isLoading}
                        dataCy={`lineKey-${element.name}`}
                    />
                ))}
            </InternalGrid>

            {children && <ButtonGroup marginTop="sm">{children}</ButtonGroup>}
        </>
    );
};

DisplayForm.propTypes = {
    data: PropTypes.object.isRequired,
    inputsNames: PropTypes.array.isRequired,
    i18labelBase: PropTypes.string.isRequired,
    isLoading: PropTypes.bool,
};

DisplayForm.defaultProps = {
    isLoading: false,
};

export default withTranslation('common', 'countries')(DisplayForm);
